import React from 'react'
import './Quote.scss'
const Qoute = () => {
  return (
    <div className='qoute-div'>
     

    <div className="comment-div ">
      <div className="comment">
        <p><i><i class=" start fas fa-quote-left"></i>
        In coding, every bug is a lesson, driving us to seek solutions and grow. Similarly, life's challenges are not setbacks but opportunities, fostering our growth and resilience.  Problems aren't obstacles ,  they are our greatest teachers.
         </i>
        </p>
       
      </div>
      <cite id="main-cite">
       		  Varun Gupta
       	</cite>
     
    </div>
  </div>


  
  )
}

export default Qoute
